module.exports = __webpack_public_path__ + "img/box1.de9383a3.png";